var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[(_vm.entityService)?_c('v-row',[_c('v-col',[_c('FormTable',{attrs:{"schemaName":'Bucket'}})],1)],1):_c('v-row',[_c('h3',[_vm._v("Não possui bucket")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }